import CSSModules from 'react-css-modules'
import {
  faCheck,
  faTriangleExclamation,
  faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import {
  ContractExtensionRequest,
  QuestionnaireStatus
} from '../../../../javascripts/api/generated'
import styles from './style.module.scss'
import { formatDate } from '../../../../javascripts/common/format'
import Pagination from "../Pagination";
export interface QuestionnaireTableProps {
  questionnaires: Array<ContractExtensionRequest>;
}

const ClientQuestionnairesTable: React.FC<QuestionnaireTableProps> = CSSModules<React.FC<QuestionnaireTableProps>>((props) => {

  const handleTableClick = (questionnaire: ContractExtensionRequest) => {
    const handler: React.MouseEventHandler<HTMLTableRowElement> = (event) => {
      event.preventDefault()

      window.location.href = questionnaire.url
    }

    return (questionnaire.status === 'unanswered') ? handler : null
  }

  const displayStatus = (status: QuestionnaireStatus) => {
    const statuses = {
      answered: { styleName: 'icon-check', text: '回答済み', icon: faCheck },
      unanswered: { styleName: 'icon-triangle-exclamation', text: '未回答', icon: faTriangleExclamation },
      expired: { styleName: 'icon-x-mark', text: '期限切れ', icon: faXmark }
    }
    return (
      <td styleName={status}>
        <span className={styles['status-icon']}>
          <FontAwesomeIcon styleName={ statuses[status]['styleName'] } icon={ statuses[status]['icon'] } />
        </span>
        {statuses[status]['text']}
      </td>
    )
  }

  const displayDeadline = (questionnaire: ContractExtensionRequest, status: QuestionnaireStatus) => {
    const statuses = {
      answered: { styleName: 'expired-deadline'},
      unanswered: { styleName: 'unanswered-deadline'},
      expired: { styleName: 'expired-deadline'}
    }
    return (
      <td styleName={statuses[status]['styleName']}>
        {formatDate(questionnaire.clientContractExtensionContractRequest?.deadline)}
      </td>
    )
  }

  return (
    <>
      <table className='client-questionnaires-table' styleName="client-questionnaires-table">
        <thead>
          <tr>
            <th className={styles['status-column']}>ステータス</th>
            <th className={styles['deadline-column']}>回答期限</th>
            <th className={styles['user-column']}>稼働者</th>
            <th className={styles['project-column']}>案件名</th>
          </tr>
        </thead>
        <tbody>
          {props.questionnaires.map((questionnaire, index) => {
            return (
              <tr key={index} styleName={questionnaire.status} onClick={handleTableClick(questionnaire)}>
                {displayStatus(questionnaire.status)}
                {displayDeadline(questionnaire, questionnaire.status)}
                <td>{questionnaire.user.fullName}</td>
                <td>{questionnaire.project.title}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </>
  )
}, styles)

export default ClientQuestionnairesTable
